module.exports = __webpack_public_path__ + "static/media/business11.416e2b99.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/business11.jpg
// module id = 91
// module chunks = 0